import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import parse from 'html-react-parser'
import he from 'he'
import YnsIcon from '~/components/icons/YnsIcon'

const RevisionDialog = ({
  revision,
  showRevisionDialog,
  toggleShowRevisionDialog,
}) => {
  const { t } = useTranslation()

  const otherDocuments = revision?.other_documents || []

  const showOtherDocuments = otherDocuments.length > 0

  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          {t('view_feedback')}
        </Stack>
      }
      variant="secondary"
      size="md"
      open={showRevisionDialog}
      onClose={() => toggleShowRevisionDialog()}
    >
      {parse(
        he.decode(
          (revision?.notes || revision?.content?.message || '')
            .replace(/\s*\{view_resume_review_button\}\s*/g, '')
            .replace(/\n/g, '<br />'),
        ),
      )}
      <br />
      <ResumeUrlWrapper showOtherDocuments={showOtherDocuments}>
        <a
          href={revision?.remote_content_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 hover:!underline"
        >
          {revision?.remote_content}
          <YnsIcon name="download" className="h-6 w-6" />
        </a>
      </ResumeUrlWrapper>
      {showOtherDocuments && (
        <div>
          <div className="font-medium">Other Documents:</div>
          <div className="flex flex-col gap-2">
            {otherDocuments.map((doc, idx) => (
              <a
                key={`other-doc-${idx}`}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:!underline"
              >
                {doc.name}
                <YnsIcon name="download" className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default RevisionDialog

const ResumeUrlWrapper = ({ showOtherDocuments, children }) => {
  if (showOtherDocuments) {
    return (
      <div>
        <div className="font-medium">Final Resume</div>
        {children}
      </div>
    )
  }
  return children
}
